export default function setSearchProductAction(searchProduct) {
    return {
        type: 'SET_SEARCH_PRODUCT',
        payload: searchProduct
    }
}